import { isGlobalProject } from 'config';
import {
  OnboardingTaxResidency,
  ClientType,
} from 'modules/onboarding/common/components';

import { useTranslation } from '../../../../libs/i18n';
import { useOwnerTaxResidency } from '../hooks';
import { PageComponentProps } from '../types';

export const OwnerTaxResidencyStep = ({ canGoBack }: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    files,
    submitDisabled,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    goToBack,
  } = useOwnerTaxResidency();

  const { t } = useTranslation();

  return (
    <OnboardingTaxResidency
      canGoBack={canGoBack}
      clientType={ClientType.Client}
      countries={countries}
      countriesLoading={countriesLoading}
      enabledFiles={isGlobalProject()}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={
        isGlobalProject()
          ? t('onboarding.taxResidency.ownerSubtitle')
          : undefined
      }
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
